import ClipboardJS from 'clipboard'
import notification from './notification'

const share = {
  init() {
    const clipboard = new ClipboardJS('.share-link')
    clipboard.on('success', function (e) {
      notification.message('Ο σύνδεσμος αντιγράφηκε στο πρόχειρο')
      e.clearSelection()
    })
  }
}
export default share
